import React, { PropTypes } from "react";
import inactivationReasonTypes, { LEAVING_FOR_COMPETITOR, OTHER } from "../../enums/inactivationReasonTypes";
import { Button } from "react-bootstrap";
import { DayPicker, SelectInput, TextInput } from "../../../../common/form";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Field, formValueSelector, reduxForm, change as changeFieldValue } from "redux-form";
import { plannedInactiveValidationRules } from "./PlannedInactiveValidationRules";
import ValidationUtils from "../../../../../utils/ValidationUtils";

const formName = "PlannedInactive";

class PlannedInactiveForm extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { lastActiveDate, inactivationReasonType } = this.props.initialValues;
        const { minDate, cancelPlanInactive, inactivationReasonTypeForm, viewOnly, disableInactiveButton } = this.props;
        let todayWithTimezone = new Date(
            new Date().toLocaleString("en-US", {
                timeZone: "America/Montreal",
            })
        );

        const dateInThreeMonths = todayWithTimezone.setMonth(todayWithTimezone.getMonth() + 3);

        const showInactivationReasonComplement =
            (lastActiveDate &&
                (inactivationReasonType == LEAVING_FOR_COMPETITOR.value || inactivationReasonType == OTHER.value)) ||
            inactivationReasonTypeForm == LEAVING_FOR_COMPETITOR.value ||
            inactivationReasonTypeForm == OTHER.value;

        return (
            <form onSubmit={this.props.handleSubmit}>
                <fieldset disabled={viewOnly}>
                    <div className="padding-bottom-2">
                        <FormattedMessage id="clients.form.client.inactivePassageModalInfo" values={{ br: <br /> }} />
                    </div>
                    <div className="padding-bottom-2">
                        <Field
                            id="lastActiveDate"
                            name="lastActiveDate"
                            disabled={!!lastActiveDate}
                            minDate={minDate}
                            maxDate={dateInThreeMonths}
                            type="text"
                            component={DayPicker}
                            utc={false}
                            required={true}
                            label={<FormattedMessage id="clients.form.client.planInactiveEndDate" />}
                        />

                        <Field
                            id="inactivationReasonType"
                            name="inactivationReasonType"
                            type="text"
                            disabled={!!lastActiveDate}
                            component={SelectInput}
                            options={inactivationReasonTypes}
                            onChange={() => this.props.changeFieldValue(formName, "inactivationReasonComplement", null)}
                            required={true}
                            label={
                                <span className="label-no-wrap">
                                    <FormattedMessage id="clients.form.client.planInactiveReason" />
                                </span>
                            }
                        />

                        {showInactivationReasonComplement && (
                            <Field
                                id="inactivationReasonComplement"
                                name="inactivationReasonComplement"
                                disabled={!!lastActiveDate}
                                type="text"
                                required={true}
                                component={TextInput}
                                label={<FormattedMessage id="clients.form.client.planInactiveComplement" />}
                            />
                        )}
                    </div>
                    {lastActiveDate && (
                        <Button onClick={() => cancelPlanInactive()} disabled={disableInactiveButton} bsStyle="primary">
                            <FormattedMessage id="clients.form.client.planInactiveCancel" />
                        </Button>
                    )}
                </fieldset>
            </form>
        );
    }
}

PlannedInactiveForm.propTypes = {
    lastActiveDate: PropTypes.string,
    minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    inactivationReasonType: PropTypes.string,
    inactivationReasonComplement: PropTypes.string,
    onSubmit: PropTypes.func,
    cancelPlanInactive: PropTypes.func,
    initialValues: PropTypes.object,
    inactivationReasonTypeForm: PropTypes.string,
    handleSubmit: PropTypes.func,
    changeFieldValue: PropTypes.func,
    viewOnly: PropTypes.bool,
    disableInactiveButton: PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch)
    };
}

function mapStateToProps(state) {
    const selector = formValueSelector("PlannedInactive");
    return {
        inactivationReasonTypeForm: selector(state, "inactivationReasonType"),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: formName,
        validate: (values) => ValidationUtils.validate(values, plannedInactiveValidationRules),
    })(PlannedInactiveForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/change-status/PlannedInactiveForm.js